export const BUSINESS = {
  name: "Vila Elevators & Escalators",
  shortName: "Vila Elevators",
  tagline: "South India's Premier Elevator & Escalator Manufacturer",
  phone: "+91 90712 21100",
  phoneRaw: "+919071221100",
  whatsapp: "919071221100",
  email: "info@vilaelevators.in",
  address: {
    line1: "No. 104 and 105, Near Bostik India Pvt. Ltd.",
    line2: "Bommasandra Industrial Area, Jigani Hobli, Anekal Taluk",
    city: "Bengaluru",
    state: "Karnataka",
    postal: "560 099",
    country: "India",
  },
  hours: "Mon – Sat · 9:00 AM – 6:30 PM",
  portalUrl: "https://app.vilaelevators.in",
  social: {
    facebook: "https://www.facebook.com/vilaelevatorsandescalators/",
    instagram: "https://www.instagram.com/vila_elevators_escalators/",
    linkedin: "https://www.linkedin.com/company/112430318/",
    youtube: "https://www.youtube.com/@vila_elevators_escalators",
  },
  mapEmbed:
    "https://www.google.com/maps/embed/v1/place?key=&q=Vila+Elevators+%26+Escalators+Bengaluru",
  mapEmbedNoKey:
    "https://maps.google.com/maps?q=Vila+Elevators+%26+Escalators+Bengaluru&t=&z=17&ie=UTF8&iwloc=&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Vila+Elevators+%26+Escalators+Bengaluru",
};

export const CITIES = [
  { slug: "bangalore", name: "Bangalore", state: "Karnataka" },
  { slug: "chennai", name: "Chennai", state: "Tamil Nadu" },
  { slug: "hyderabad", name: "Hyderabad", state: "Telangana" },
  { slug: "vijayawada", name: "Vijayawada", state: "Andhra Pradesh" },
  { slug: "coimbatore", name: "Coimbatore", state: "Tamil Nadu" },
  { slug: "mysuru", name: "Mysuru", state: "Karnataka" },
  { slug: "mangaluru", name: "Mangaluru", state: "Karnataka" },
  { slug: "hubballi", name: "Hubballi", state: "Karnataka" },
  { slug: "belagavi", name: "Belagavi", state: "Karnataka" },
  { slug: "tumakuru", name: "Tumakuru", state: "Karnataka" },
  { slug: "shivamogga", name: "Shivamogga", state: "Karnataka" },
  { slug: "udupi", name: "Udupi", state: "Karnataka" },
  { slug: "visakhapatnam", name: "Visakhapatnam", state: "Andhra Pradesh" },
];

export const MEDIA = {
  hero: "/images/hero-corridor.webp",
  productElevator: "/images/cabin-interior.webp",
  homeLift: "/images/home-lift-cabin.png",
  homeLiftLifestyle: "/images/home-lift-lifestyle.webp",
  lobby: "/images/lobby.webp",
  productEscalator: "/images/escalator.webp",
  hospitalLobby: "/images/hospital-lobby.webp",
  freightEntrance: "/images/freight-entrance.webp",
  neonLift: "/images/neon-lift.webp",
  darkCabin: "/images/dark-cabin.webp",
  cnc: "/images/cnc.jpg",
  bangalore: "/images/bangalore.jpg",
};
